import { combineReducers } from "@reduxjs/toolkit";
import themeColorReducer from "@/store/themeColor/themeColorSlice";
import categoryFilterReducer from "@/store/statistics/categoryFilterSlice";
import periodFilterReducer from "@/store/statistics/periodFilterSlice";
import statusFilterReducer from "@/store/statistics/statusFilterSlice";
import sparxsListReducer from "@/store/sparxsCatalog/listSlice";
import sparxsBlueprintCacheReducer from "@/store/sparxsCatalog/blueprintCacheSlice";
import selectedInputFieldReducer from "@/features/sparxsEditor/store/slices/interaction/selectedInputField";
import activeSparxReducer from "@/features/sparxsEditor/store/slices/document/activeDocument";
import sparxsEventHandlerReducer from "@/features/sparxsEditor/store/slices/interaction/eventHandlerSlice";
import formStateReducer from "@/features/sparxsEditor/store/slices/interaction/formStateSlice";
import sparxReducer from "@/features/sparxsEditor/store/slices/document/documentSlice";
import sparxTeaserReducer from "@/features/sparxsEditor/store/slices/document/sparxTeaserSlice";
import sparxSessionReducer from "@/features/sparxsEditor/store/slices/session/sessionSlice";
import sessionPreferencesReducer from "@/features/sparxsEditor/store/slices/session/sessionPreferencesSlice";
import conflictReducer from "@/features/sparxsEditor/store/slices/conflict/conflictSlice";
import sparxsSearchIndexReducer from "@/store/sparxsCatalog/searchIndexSlice";
import sparxsBlueprintFetchFailuresReducer from "@/store/sparxsCatalog/blueprintFetchFailuresSlice";
import catalogSearchReducer from "@/features/sparxsEditor/store/slices/catalog/catalogSearchSlice";
import blueprintLoadBoundaryReducer from "@/features/sparxsEditor/store/slices/blueprintLoadBoundarySlice";
import sparxReactionsReducer from "@/features/sparxsEditor/store/slices/reactions/sparxReactionsSlice";
import editorEntryBlockedReducer from "@/store/sparxsCatalog/editorEntryBlockedSlice";
import navigationRouteReducer from "@/store/navigation/navigationRouteSlice";
import requestsReducer from "@/store/requests/requestsSlice";
import featuresReducer from "@/store/user/featureSlice";
import userProfileReducer from "@/store/user/userProfileSlice";
import { sparxsEditorEditorReducer } from "@/store/app/sparxsEditorEditorReducer";

const statisticsReducer = combineReducers({
  categoryFilter: categoryFilterReducer,
  statusFilter: statusFilterReducer,
  periodFilter: periodFilterReducer,
});

const editorReducerForTest = combineReducers({
  sparxsList: sparxsListReducer,
  sparxsBlueprintCache: sparxsBlueprintCacheReducer,
  sparx: sparxReducer,
  sparxTeaser: sparxTeaserReducer,
  sparxSession: sparxSessionReducer,
  sessionPreferences: sessionPreferencesReducer,
  conflict: conflictReducer,
  selectedInputField: selectedInputFieldReducer,
  activeSparx: activeSparxReducer,
  sparxsEventHandler: sparxsEventHandlerReducer,
  formState: formStateReducer,
  sparxsSearchIndex: sparxsSearchIndexReducer,
  sparxsBlueprintFetchFailures: sparxsBlueprintFetchFailuresReducer,
  blueprintLoadBoundary: blueprintLoadBoundaryReducer,
  editorEntryBlocked: editorEntryBlockedReducer,
  catalogSearch: catalogSearchReducer,
  sparxReactions: sparxReactionsReducer,
});

const userReducer = combineReducers({
  userProfile: userProfileReducer,
  features: featuresReducer,
});

export const rootReducer = combineReducers({
  themeColor: themeColorReducer,
  statistics: statisticsReducer,
  navigationRoute: navigationRouteReducer,
  editor: sparxsEditorEditorReducer,
  user: userReducer,
  requests: requestsReducer,
});

/** Root reducer without persist; for Storybook/mock store so unit tests never load createAppStore / full app bootstrap. */
export const rootReducerForTest = combineReducers({
  themeColor: themeColorReducer,
  statistics: statisticsReducer,
  navigationRoute: navigationRouteReducer,
  editor: editorReducerForTest,
  user: userReducer,
  requests: requestsReducer,
});

export type RootStateFromTest = ReturnType<typeof rootReducerForTest>;
